/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Card, Container, LinearProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import TestBody from './components/TestBody';
import TestFinished from './components/TestFinished';
import Landing from './components/Landing';
import placementTestServices from '../../redux/services/placementTestServices';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%',
    overflowY: 'auto',
    marginTop: theme.spacing(1),
    position: 'relative',
  },
  progressBar: {
    width: '100%',
    height: '5px',
  },
}));

const PlacementTest = ({
  test, currentQuestion, answers, auth, _id,
}) => {
  const [testDone, setTestDone] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    placementTestServices.getTest(_id)
      .then((res) => {
        if (res && res.scores && res.answers.length === 60) {
          setTestDone(true);
        }
      })
      .catch();
  }, []);

  return testDone || auth.placementTest === false ? (<Redirect to="/home" />) : (
    <>
      <Container>
        <Card variant="outlined" className={classes.root}>
          {test ? (
            (currentQuestion === test.questions.length) ? (
              <TestFinished testId={test.testId} answers={answers} />
            ) : (
              <>
                <TestBody
                  descriptionRC={test.descriptionRC}
                  descriptionOC={test.descriptionOC}
                  descriptionKN={test.descriptionKN}
                  testData={test.questions}
                />
                <LinearProgress
                  className={classes.progressBar}
                  variant="determinate"
                  value={test ? ((currentQuestion / test.questions.length) * 100) : 0}
                />
              </>
            )
          ) : (
            <Landing />
          )}
        </Card>
      </Container>
    </>
  );
};

PlacementTest.propTypes = {
  test: PropTypes.object.isRequired,
  currentQuestion: PropTypes.number.isRequired,
  answers: PropTypes.array.isRequired,
};

function mapState(state) {
  const { auth, isTest } = state.authentication;
  const {
    requestingTest, test, answers, currentQuestion,
  } = state.placementTest;
  const { _id, code } = auth;
  return {
    code,
    _id,
    requestingTest,
    test,
    isTest,
    answers,
    currentQuestion,
    auth,
  };
}
export default connect(mapState)(PlacementTest);
